import SearchHistoryOverview from 'components/SearchHistoryOverview/SearchHistoryOverview';

export default SearchHistoryOverview;
